import React from 'react';
import PageHeader from 'react-bootstrap/lib/PageHeader';

const HomePage = () => (
  <div>
    <PageHeader>Welcome to Fusion</PageHeader>
    <p>
      Fusion is a comprehensive and opinionated React development framework for
      Cox Automotive. All{' '}
      <a href="https://ghe.coxautoinc.com/CoxAuto-UI/fusion/blob/master/packages/fusion-core/package.json#L26">
        this project's dependencies
      </a>{' '}
      are encapsulated within{' '}
      <a href="https://www.npmjs.com/package/@coxautokc/fusion">
        a single npm package called fusion
      </a>. This enables easy updates later. This project includes a suite of{' '}
      <a href="https://fusion-ui.firebaseapp.com">reusable components</a> that
      are styled to match the{' '}
      <a href="http://www.get-tracksuit.com">Tracksuit style guide</a>{' '}
      (password: suit-up).
    </p>

    <h2>Next Steps</h2>
    <ol>
      <li>
        Read the{' '}
        <a href="https://ghe.coxautoinc.com/CoxAuto-UI/fusion/blob/master/packages/fusion-starter/README.md">
          Fusion-starter Readme
        </a>.
      </li>
      <li>
        Try the examples listed to the left and review their source code to see
        how they work.
      </li>
      <li>
        Review the suite of{' '}
        <a href="https://fusion-ui.firebaseapp.com">Fusion UI Components</a>.
        Note that many components use{' '}
        <a href="https://react-bootstrap.github.io/components.html">
          React-Bootstrap{' '}
        </a>behind the scenes.
      </li>
      <li>
        Run <code>npm run remove-demo</code> to remove this demo app and start
        coding! 🎉
      </li>
    </ol>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.js